/**
 *  When clicked on element with 'data-cookie' attribute,
 *  cookie value is set to the value specified by the element.
 *
 *  if data-cookie-value is present, its value is used, otherwise
 *  jQuery.fn.val is used instead.
 *
 *  Example:
 *  <button type="button" data-cookie="myCookie" data-cookie-value="myValue">Click me!</button>
 *  will set the cookie with name "myCookie" to value "myValue".
 */
import $ from 'jquery'
import cookie from '../cookie'
import oneTimeInitializer from '../internal/oneTimeInitializer';

function init() {
    $(document).on('click', '[data-cookie]', function () {
        const $this = $(this);
        const cookieName = $this.attr('data-cookie');
        const cookieValue = $this.attr('data-cookie-value') || $this.val();
        cookie.setCookie(cookieName, cookieValue);
    });
}

export default oneTimeInitializer(init);


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/cookieValue.js